import { render } from "./DisplayInput.vue?vue&type=template&id=6b1644c4&scoped=true"
import script from "./DisplayInput.vue?vue&type=script&lang=js"
export * from "./DisplayInput.vue?vue&type=script&lang=js"

import "./DisplayInput.vue?vue&type=style&index=0&id=6b1644c4&scoped=true&lang=scss"

import exportComponent from "/usr/share/nginx/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b1644c4"]])

export default __exports__